import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { coreInstance } from 'shared/axios'
import { QUERY_KEYS } from './queryKey'

const getPermissions = () =>
  coreInstance
    .get<{
      permissions: Record<string, string[]>
    }>('v1/profile/person_permissions')
    .then((res) => res.data.permissions)

export const useUserPermissions = <T = Record<string, string[]>>(
  select?: (data: Record<string, string[]>) => T,
  options?: Partial<UseQueryOptions<Record<string, string[]>, Error, T>>,
) =>
  useQuery({
    queryKey: QUERY_KEYS.permissions,
    queryFn: getPermissions,
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
    select,
  })
